import { defineStore } from "pinia";
import { reactive } from "vue";

export const useSolicitanteStore = defineStore(
  "solicitante",
  () => {
    const solicitante = reactive({
      nombre: null,
      paterno: null,
      materno: null,
      denominacion_social: null,
      persona: null,
      actua_derecho_propio: null,
      existente: null,
    });

    const nombreCompleto = computed(() => {
      return [solicitante.nombre, solicitante.paterno, solicitante.materno].filter(Boolean).join(" ");
    });

    function resetSolicitante() {
      solicitante.nombre = null;
      solicitante.paterno = null;
      solicitante.materno = null;
      solicitante.denominacion_social = null;
      solicitante.persona = null;
    }

    return { solicitante, nombreCompleto, resetSolicitante };
  },
  {
    persist: false,
  },
);
